import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

interface IStubSettingsInfoSetupFieldsPanel {}
export const StubSettingsInfoSetupFieldsPanel: FC<
	IStubSettingsInfoSetupFieldsPanel
> = ({}) => {
	return (
		<div style={{ padding: "0" }}>
			<EnhancedDropDownRHFWithLabel
				selectName="language"
				label="Language"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Language-list`}
				items={[
					{ label: "English", value: 100 },
					{ label: "French", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="hoursAndRate"
				label="Hours & rate"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Hours-&-rate-list`}
				items={[
					{ label: "Print", value: 200 },
					{ label: "Do not Print", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="vactionPayDue"
				label="Vaction pay due"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Vaction-pay-due-list`}
				items={[
					{ label: "Print", value: 200 },
					{ label: "Do not Print", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="holidayPayDue"
				label="Holiday Pay due"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Holiday-Pay-due-list`}
				items={[
					{ label: "Print", value: 200 },
					{ label: "Do not Print", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="companyName"
				label="Company Name"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Company-Name`}
				items={[
					{ label: "Legal Name", value: 100 },
					{ label: " Operating As", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="cashAdvanceDeduction"
				label="Cash Advance Deduction"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Cash-Advance-Deduction-list`}
				items={[
					{ label: "Print", value: 200 },
					{ label: "Do not Print", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="emailStub"
				label="Email Stub"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Email-Stub`}
				items={[
					{ label: "Stub Only", value: 100 },
					{ label: "Stub with E&D Details", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="passwordOnEmailStub"
				label="Password on Email Stub"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Password-on-Email-Stub`}
				items={[
					{ label: "No", value: 100 },
					{ label: "Yes", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="hourlyRate"
				label="Hourly Rate"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Hourly-Rate-Stub`}
				items={[
					{ label: "Print", value: 200 },
					{ label: "Do not Print", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="paymentDate"
				label="Payment Date"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Payment-Date`}
				items={[
					{ label: "Print", value: 200 },
					{ label: "Do not Print", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				placeholder="Notes"
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			/>
		</div>
	);
};
